// Standard UPI payment link (what UPI QR codes contain). Any UPI app can open it.
// The UPI ID keeps its plain "@" (some apps cannot read "%40"); the name is percent-encoded.
const VPA = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+$/;

export const upiUri = (vpa, name, amount) => {
  if (!VPA.test(vpa)) throw new Error(`Not a valid UPI ID: ${vpa}`);
  let uri = `upi://pay?pa=${vpa}&pn=${encodeURIComponent(name)}&cu=INR`;
  if (amount) uri += `&am=${Number(amount).toFixed(2)}`;
  return uri;
};
